import {
  GET_CHECKLISTS_REQUEST,
  GET_CHECKLISTS_SUCCESS,
  GET_CHECKLISTS_FAILURE,
  GET_FIRST_CHECKLISTS_REQUEST,
  GET_FIRST_CHECKLISTS_SUCCESS,
  GET_FIRST_CHECKLISTS_FAILURE,
  UPLOAD_CHECKLIST_FAILURE,
  UPLOAD_CHECKLIST_REQUEST,
  SET_PROJECT_ID
} from "./actions";

const initialState = {
  checklists: [],
  firstLoad: false,
  isChanged: false,
  uploadError: false,

  isLoaded: false,

  selectedProjectId: false,
  isProjectOwner: true
};

export default function filesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CHECKLISTS_SUCCESS: {
      return { ...state, checklists: action.payload, isChanged: false, isLoaded: true};
    }
    case GET_FIRST_CHECKLISTS_REQUEST: {
      return { ...state, firstLoad: true, isLoaded: false };
    }
    case GET_FIRST_CHECKLISTS_SUCCESS: {
      return { ...state, firstLoad: false };
    }
    case GET_FIRST_CHECKLISTS_FAILURE: {
      return { ...state, firstLoad: false };
    }
    case GET_CHECKLISTS_REQUEST: {
      return { ...state, isChanged: true, isLoaded: false };
    }
    case GET_CHECKLISTS_FAILURE: {
      return { ...state, isChanged: false };
    }
    case UPLOAD_CHECKLIST_FAILURE: {
      return { ...state, isChanged: false, uploadError: action.payload };
    }
    case UPLOAD_CHECKLIST_REQUEST: {
      return { ...state, isChanged: true, isLoaded: false };
    }
    case SET_PROJECT_ID: {
      return { ...state, selectedProjectId: action.payload.projectId, isProjectOwner: action.payload.isProjectOwner };
    }

    default:
      return { ...state };
  }
}
